import { render, staticRenderFns } from "./PatrimoineFatCard.vue?vue&type=template&id=1b7f9758&scoped=true&"
import script from "./PatrimoineFatCard.vue?vue&type=script&lang=js&"
export * from "./PatrimoineFatCard.vue?vue&type=script&lang=js&"
import style0 from "./PatrimoineFatCard.vue?vue&type=style&index=0&id=1b7f9758&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f9758",
  null
  
)

export default component.exports